import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

import { MinimalSubscription } from "../../../pages/subscription-detail/types";
import { NotificationButton } from "../notification-button/notification-button";
import { ReportIncident } from "../report-incident/report-incident";

@Component({
  selector: "subscription-detail-header",
  templateUrl: "subscription-detail-header.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NotificationButton, ReportIncident, AngularSvgIconModule, MatTooltip],
})
export class SubscriptionDetailHeader {
  protected subscription = input.required<MinimalSubscription>();
  showNotificationButton = input<boolean>(true);
  showReportIncidentButton = input.required<boolean>();
  titleKey = input<string>("ServiceDetails");

  protected isTerminated = computed(() => this.subscription().status === "terminated");
  isDirty = computed(() => this.subscription().dirty);
}
